<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
  },
  components: {
  },
  watch: {
    // 按需加载路由，监听路由变化逻辑处理
    $route (to, from) {
      const _this = this // 这里注意一下记得缓存this
      _this.$router.push({
        path: _this.$route.path, // 这个值我们是可以拿到的
        query: _this.$route.query,
        params: _this.$route.params,
        fullPath: _this.$route.fullPath,
        meta: _this.$route.meta,
        hash: _this.$route.hash,
        matched: _this.$route.matched,
        name: _this.$route.name
      })
    }
  }
}
</script>

<style lang="scss">
@import 'assets/css/reset.scss';
.mains {
  overflow: hidden;
  margin: 0 auto;
  width: 1200px;
  background: #fff;
  min-height: calc(100vh - 300px);
}
</style>
